import { DEFAULT_BASE_URL } from "../constants/authConstants";
import { saveSession, clearSession } from "../../../security/session";

export function getBaseURL() {
  const rawURL = process.env.REACT_APP_API_BASE_URL || DEFAULT_BASE_URL;
  return rawURL.replace(/\/$/, "");
}

export function clearAuthFlag() {
  clearSession();
}

export function saveAuthSession({ token, username, grupo, roles, permissions, is_superuser, isSuperuser, superuser, authMode, remember }) {
  const normalizedUsername = String(username || "").trim().toLowerCase();
  const isSuper =
    is_superuser === true ||
    isSuperuser === true ||
    superuser === true ||
    normalizedUsername === "superuser" ||
    normalizedUsername === "administrator";

  saveSession({ token, username, grupo, roles, permissions, isSuperuser: isSuper, authMode, remember });
}
